define('views/parts/form/button',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/form/button.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TFixedButton
) {

    /**
     * Creates an input box with an inline dynamic label
     * and provides two-way binding via Epoxy.
     *
     * If fixed, add `.btn-bottom` to the previous sibling div.
     *
     * @param  {string} type - of the button.
     * @param  {string} label - inside the button.
     * @param  {string} icon - inside the button.
     * @param  {string} id - of the button.
     * @param  {string} class - additionnal classes.
     * @param  {Boolean} fixed - if you want it to the bottom of the view.
     * @param  {Object} context
     * @param  {Function} callback - to be called on click.
     */
    var VButton = Backbone.View.extend({
        template: TFixedButton,
        events: {
            "click button": "onClick",
        },
        regions: {
            button: "button",
            buttonLink: "a",
            text: ".button-text",
            icon: ".icon",
        },
        initialize: function(opt) {
            this.options = _.extend({
                label: "Click me!",
                type: "button",
                icon: "sl-icon-check",
                fixed: false,
                url: false,
                block: false,
                tcClass: true,
            }, opt);

        },
        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.options));
            this.$el.empty().append(html);
            this.generateZones();

            this.toggleFixed(this.options.fixed);

            return this;
        },

        toggle: function(val) {
            this.$el.toggleClass('hide', val);
        },

        toggleFixed: function(val) {
            this.options.fixed = _.isUndefined(val) ? !this.options.fixed : val;
            this.$el.toggleClass("panel-fixed-bottom", this.options.fixed);
        },

        toggleDisabled: function(val) {
            if (!this.zone) return;
            this.zone.$button.toggleDisabled(val);
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            // default context to 'this'.
            var context = this.options.context || this,
                callback = this.options.callback;

            _.callback(context, callback, [e]);

            this.trigger("click", e);
        },

        setLabel: function(label) {
            if (this.zone) this.zone.$text.text(label);
            else this.options.label = label;
            return this;
        },

        setCallback: function(callback) {
            this.options.callback = callback;
        },

        setUrl: function(url) {
            if (this.zone) this.zone.$buttonLink.attr('href', url);
            else this.options.url = url;
            return this;
        },

    }, {
        ///////////////////////
        // Static properties //
        ///////////////////////
        create: function(label, type, callback, context, options) {
            return new VButton(_.extend({
                label: label,
                type: type,
                callback: callback,
                context: context
            }, options));
        }
    });

    return VButton;

});

